module.exports = require("swagger-client");


//////////////////
// WEBPACK FOOTER
// external "swagger-client"
// module id = 284
// module chunks = 0